/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from "react";
import { apiTest, apiBackOffice, apiCorreios } from "./utils/api";
import { money } from "~hooks/useHelpers";
import { db } from "~db/db";
import { resetMapa } from "~pages/PriceSearchV2/utils/searchHelpers";

export const getUserInfos = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`api/Usuario/FindOrCreate`, { params: { origem: "HUB VenD+" } });
  return res;
};

export const getUserByEmail = async (email) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`api/Usuario/${email}`);

  if (res.data !== undefined) return res.data;

  return res;
};

export const getVendedores = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiBackOffice.get(`api/Usuario/Vendedores`);
  return res;
};

export const AcessosSlug = (array, key) => {
  return array?.includes(key) || array?.includes("acesso-ao-hub");
};

export function removingFormatting(value) {
  value = typeof value == "number" ? value.toString() : value;
  value = value ?? "";
  const numeric = value.replace(/[^\d,]/g, "").replace(",", ".");

  const number = Number(numeric);
  if (isNaN(number)) {
    return 0;
  }
  return number;
}

export function filterDataUltimosDias(data, filter, campo) {
  data = data.map((el) => {
    return {
      ...el,
      data: new Date(el.data),
    };
  });
  data = data.filter((el) => {
    let a = new Date();
    a.setDate(a.getDate() - filter);
    a.setHours(0, 0, 0);
    let b = new Date(el[campo]);
    return b.getTime() > a.getTime();
  });
  return data;
}

export function filterGenerico(data, campoA, campoB) {
  return (data || []).filter((filtrar) => filtrar[campoA] === campoB);
}

export function getTrilhaCliente(codigo) {
  const trilhasCliente = {
    400: "TAC",
    410: "IMO",
    420: "IND",
    430: "INFRA",
  };
  return trilhasCliente[codigo];
}

export function getTemaSolicitacao() {
  const temas = {
    1: "Cadastro Recebedor",
    2: "Cadastro Emissor",
    3: "Atualização Recebedor",
    4: "Atualização Emissor",
    5: "Limite Crédito",
    6: "Conversão de Prospect",
  };
  return temas;
}

export function editMaskCNPJCPF(documento) {
  if (!documento || typeof documento !== "string") return "";

  const onlyDigits = documento.replace(/\D/g, "");

  if (onlyDigits.length === 14) {
    return onlyDigits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  } else if (onlyDigits.length === 11) {
    return onlyDigits.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  } else {
    return documento;
  }
}

export function editMaskCEP(cep) {
  if (!cep) return "";
  if (cep.length === 8) {
    return cep.replace(/^(\d{5})(\d{2})/, "$1-$2");
  } else {
    return cep;
  }
}

export function getTipoPessoa() {
  return [
    {
      value: 1,
      label: "CPF - Pessoa Fisica",
    },
    {
      value: 2,
      label: "CNPJ - Pessoa Juridica",
    },
    {
      value: 3,
      label: "CNOB - Obra de Pessoa Juridica",
    },
    {
      value: 4,
      label: "PNSD - Obra de Pessoa Fisica",
    },
  ];
}

export const diffEnabledRequest = (lastUpdate) => {
  const now = new Date();
  const diffMs = now - lastUpdate;
  const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
  if (diffMins >= 30) {
    return true;
  }
  return false;
};

export const porcentagem = (valor) => {
  valor = valor.toFixed(2);
  valor = valor.replace(".", ",");
  return valor + "%";
};

export function formatarData(data) {
  const meses = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

  const partes = data.split("/");
  const dia = partes[0];
  const mesNumero = parseInt(partes[1], 10) - 1;

  const mesEscrito = meses[mesNumero];

  return `${mesEscrito}/${dia}`;
}

export function formatarDataparaBR(data) {
  const dataInicial = new Date(data);
  const dia = String(dataInicial.getDate()).padStart(2, "0");
  const mes = String(dataInicial.getMonth() + 1).padStart(2, "0");
  const ano = dataInicial.getFullYear();
  const dataFormatada = `${dia}/${mes}/${ano}`;
  return dataFormatada;
}

export function getEstruturaSincronizacao(table = "") {
  let id = 0;
  const estrutura = {
    trilhas: { id: ++id, table: "trilhas", nome: "Trilha", quantidade: 0, data: null },
    canaisDistribuicao: {
      id: ++id,
      table: "canaisDistribuicao",
      nome: "Canais de distribuição",
      quantidade: 0,
      data: null,
    },
    cidades: { id: ++id, table: "cidades", nome: "Cidades", quantidade: 0, data: null },
    contexto: { id: ++id, table: "contexto", nome: "Contextos", quantidade: 0, data: null },
    embalagens: { id: ++id, table: "embalagens", nome: "Embalagens", quantidade: 0, data: null },
    empresas: { id: ++id, table: "empresas", nome: "Empresas", quantidade: 0, data: null },
    estados: { id: ++id, table: "estados", nome: "Estados", quantidade: 0, data: null },
    familiaProdutos: { id: ++id, table: "familiaProdutos", nome: "Familia de produtos", quantidade: 0, data: null },
    filiais: { id: ++id, table: "filiais", nome: "Filiais", quantidade: 0, data: null },
    grupoCentralizador: {
      id: ++id,
      table: "grupoCentralizador",
      nome: "Grupos de centralizadores",
      quantidade: 0,
      data: null,
    },
    grupoProdutos: { id: ++id, table: "grupoProdutos", nome: "Grupos de produtos", quantidade: 0, data: null },
    subGrupoMaterial: { id: ++id, table: "subGrupoMaterial", nome: "SubGrupos de produtos", quantidade: 0, data: null },
    grupoSegmento: { id: ++id, table: "grupoSegmento", nome: "Grupos de segmentos", quantidade: 0, data: null },
    local: { id: ++id, table: "local", nome: "Locais", quantidade: 0, data: null },
    localTrilha: { id: ++id, table: "localTrilha", nome: "Local - Trilhas", quantidade: 0, data: null },
    prazoPagamento: { id: ++id, table: "prazoPagamento", nome: "Prazos de pagamento", quantidade: 0, data: null },
    precosCliente: { id: ++id, table: "precosCliente", nome: "Preços de cliente", quantidade: 0, data: null },
    tabelaPreco: { id: ++id, table: "tabelaPreco", nome: "Tabela de preços", quantidade: 0, data: null },
    produtos: { id: ++id, table: "produtos", nome: "Produtos", quantidade: 0, data: null },
    produtosFiliais: { id: ++id, table: "produtosFiliais", nome: "Produtos nas Filiais", quantidade: 0, data: null },
    segmento: { id: ++id, table: "segmento", nome: "Segmentos", quantidade: 0, data: null },
    servico: { id: ++id, table: "servico", nome: "Serviços", quantidade: 0, data: null },
    simulacoes: { id: ++id, table: "simulacoes", nome: "Simulações", quantidade: 0, data: null },
    tipoCondicao: { id: ++id, table: "tipoCondicao", nome: "Tipos de Condição", quantidade: 0, data: null },
    cep: { id: ++id, table: "cep", nome: "CEPs", quantidade: 0, data: null },
    hierarquiasAprovacao: {
      id: ++id,
      table: "hierarquiasAprovacao",
      nome: "Hierarquias de Aprovação",
      quantidade: 0,
      data: null,
    },
    unidadeMedidas: { id: ++id, table: "unidadeMedidas", nome: "Unidades de Medida", quantidade: 0, data: null },
    motivo: { id: ++id, table: "motivo", nome: "Motivos Comerciais", quantidade: 0, data: null },
    parametros: { id: ++id, table: "parametros", nome: "Parâmetros", quantidade: 0, data: null },
    pesquisaCanalDistribuicao: {
      id: ++id,
      table: "pesquisaCanalDistribuicao",
      nome: "Mapa da Mina - Canais de Distribuição",
      quantidade: 0,
      data: null,
    },
    pesquisaGrupoMaterialCanalDistribuicao: {
      id: ++id,
      table: "pesquisaGrupoMaterialCanalDistribuicao",
      nome: "Mapa da Mina - Grupo de Materiais em Canais de Distribuição",
      quantidade: 0,
      data: null,
    },
    pesquisaMedidas: { id: ++id, table: "pesquisaMedidas", nome: "Mapa da Mina - Medidas", quantidade: 0, data: null },
    pesquisaPlayers: { id: ++id, table: "pesquisaPlayers", nome: "Mapa da Mina - Players", quantidade: 0, data: null },
    pesquisaGrupoMaterialPlayer: {
      id: ++id,
      table: "pesquisaGrupoMaterialPlayer",
      nome: "Mapa da Mina - Grupo de Materiais Player",
      quantidade: 0,
      data: null,
    },
    pesquisaPrazos: { id: ++id, table: "pesquisaPrazos", nome: "Mapa da Mina - Prazos", quantidade: 0, data: null },
    pesquisaGrupoMaterialPrazo: {
      id: ++id,
      table: "pesquisaGrupoMaterialPrazo",
      nome: "Mapa da Mina - Grupo de Materiais em Prazos",
      quantidade: 0,
      data: null,
    },
    pesquisaProdutos: {
      id: ++id,
      table: "pesquisaProdutos",
      nome: "Mapa da Mina - Produtos",
      quantidade: 0,
      data: null,
    },
    pesquisaEmbalagem: {
      id: ++id,
      table: "pesquisaEmbalagem",
      nome: "Mapa da Mina - Embalagens",
      quantidade: 0,
      data: null,
    },
    pesquisaGrupoMaterial: {
      id: ++id,
      table: "pesquisaGrupoMaterial",
      nome: "Mapa da Mina - Grupo de Materiais",
      quantidade: 0,
      data: null,
    },
    pesquisaGrupoMaterialUnidadeMedida: {
      id: ++id,
      table: "pesquisaGrupoMaterialUnidadeMedida",
      nome: "Mapa da Mina - Grupo de Materiais por Unidade de Medida",
      quantidade: 0,
      data: null,
    },
    pesquisaGrupoMaterialEmbalagem: {
      id: ++id,
      table: "pesquisaGrupoMaterialEmbalagem",
      nome: "Mapa da Mina - Grupo de Materiais por Embalagem",
      quantidade: 0,
      data: null,
    },
    pesquisaCentroOrigem: {
      id: ++id,
      table: "pesquisaCentroOrigem",
      nome: "Mapa da Mina - Centro/Origem",
      quantidade: 0,
      data: null,
    },
    pesquisaPlayerCentroOrigem: {
      id: ++id,
      table: "pesquisaPlayerCentroOrigem",
      nome: "Mapa da Mina - Player/Centro - Origem",
      quantidade: 0,
      data: null,
    },
    pesquisaMotivoCompra: {
      id: ++id,
      table: "pesquisaMotivoCompra",
      nome: "Mapa da Mina - Motivo de Compra",
      quantidade: 0,
      data: null,
    },
    pesquisaGruposObrigatorios: {
      id: ++id,
      table: "pesquisaGruposObrigatorios",
      nome: "Mapa da Mina - Grupos Obrigatórios",
      quantidade: 0,
      data: null,
    },
    buscaOnline: { id: ++id, table: "buscaOnline", nome: "Busca Online", quantidade: 0, data: null },
    documentos: { id: ++id, table: "documentos", nome: "Documentos", quantidade: 0, data: null },
    ultimosUploadsDocumentos: {
      id: ++id,
      table: "ultimosUploadsDocumentos",
      nome: "Data de Uploads - Documentos",
      quantidade: 0,
      data: null,
    },
    funilObraGrupoProdutos: {
      id: ++id,
      table: "funilObraGrupoProdutos",
      nome: "Funil de Obras - Grupo de Produtos",
      quantidade: 0,
      data: null,
    },
    funilObraProdutos: {
      id: ++id,
      table: "funilObraProdutos",
      nome: "Funil de Obras - Produtos",
      quantidade: 0,
      data: null,
    },
    produtosConcorrente: {
      id: ++id,
      table: "produtosConcorrente",
      nome: "Produtos Concorrentes",
      quantidade: 0,
      data: null,
    },
    funilStatus: { id: ++id, table: "funilStatus", nome: "Status do funil", quantidade: 0, data: null },
    funilStatusGrupo: {
      id: ++id,
      table: "funilStatusGrupo",
      nome: "Status do grupo de funil",
      quantidade: 0,
      data: null,
    },
    prazoRegra: { id: ++id, table: "prazoRegra", nome: "Prazos Regra", quantidade: 0, data: null },
    vendedores: { id: ++id, table: "vendedores", nome: "Vendedores", quantidade: 0, data: null },
    cargos: { id: ++id, table: "cargos", nome: "Cargos", quantidade: 0, data: null },
    cluster: { id: ++id, table: "cluster", nome: "Clusters", quantidade: 0, data: null },
    rotas: { id: ++id, table: "rotas", nome: "Rotas", quantidade: 0, data: null },
    infosTatica: { id: ++id, table: "infosTatica", nome: "Infos Tatica", quantidade: 0, data: null },
    missoes: { id: ++id, table: "missoes", nome: "Missões", quantidade: 0, data: null },
    faturamentos: { id: ++id, table: "faturamentos", nome: "Faturamentos", quantidade: 0, data: null },
    ordenacaoTabelaPreco: {
      id: ++id,
      table: "ordenacaoTabelaPreco",
      nome: "Tabela de preços",
      quantidade: 0,
      data: null,
    },
    tabelaPrecoCliente: {
      id: ++id,
      table: "tabelaPrecoCliente",
      nome: "Tabela de preços cliente",
      quantidade: 0,
      data: null,
    },
    microrregiao: { id: ++id, table: "microrregiao", nome: "Microrregiões", quantidade: 0, data: null },
    motivos: { id: ++id, table: "motivos", nome: "Motivos", quantidade: 0, data: null },
    cliente: { id: ++id, table: "cliente", nome: "Carteira", quantidade: 0, data: null },
    reflex: { id: ++id, table: "reflex", nome: "Reflex", quantidade: 0, data: null },
    posicaoCarga: { id: ++id, table: "posicaoCarga", nome: "Posição de carga", quantidade: 0, data: null },
    autosservico: { id: ++id, table: "autosservico", nome: "Autosserviço", quantidade: 0, data: null },
    creditoCliente: { id: ++id, table: "creditoCliente", nome: "Crédito de clientes", quantidade: 0, data: null },
    forcaVenda: { id: ++id, table: "forcaVenda", nome: "Força de venda", quantidade: 0, data: null },
    erroPesquisa: { id: ++id, table: "erroPesquisa", nome: "Erro de pesquisa", quantidade: 0, data: null },
    erroPesquisaVendedor: { id: ++id, table: "erroPesquisaVendedor", nome: "Erro de pesquisa por vendedor", quantidade: 0, data: null },
    bateuLevou: { id: ++id, table: "bateuLevou", nome: "Bateu Levou", quantidade: 0, data: null },
    super4: { id: ++id, table: "super4", nome: "Super4", quantidade: 0, data: null },
    vloz: { id: ++id, table: "vloz", nome: "Vloz", quantidade: 0, data: null },
    passouGanhou: { id: ++id, table: "passouGanhou", nome: "Passou Ganhou", quantidade: 0, data: null },
    gvFaturamento: { id: ++id, table: "gvFaturamento", nome: "GV Faturamento", quantidade: 0, data: null },
    clienteShare: { id: ++id, table: "clienteShare", nome: "Cliente Share", quantidade: 0, data: null },
    parametroReflex: { id: ++id, table: "parametroReflex", nome: "parametroReflex", quantidade: 0, data: null },
    niveisServico: { id: ++id, table: "niveisServico", nome: "Niveis de Serviços", quantidade: 0, data: null },
    motivosPerda: { id: ++id, table: "motivosPerda", nome: "Motivos de Perda", quantidade: 0, data: null },
    funilObraConcorrente: { id: ++id, table: "funilObraConcorrente", nome: "Funil de Obras - Concorrentes", quantidade: 0, data: null },
    funilObraMotivoPerda: { id: ++id, table: "funilObraMotivoPerda", nome: "Funil de Obras - Motivos de Perda", quantidade: 0, data: null },
    funilObraConsorcio: {
      id: ++id,
      table: "funilObraConsorcio",
      nome: "Funil de Obras - Consorcios",
      quantidade: 0,
      data: null,
    },
    funilObraEmpresasLider: {
      id: ++id,
      table: "funilObraEmpresasLider",
      nome: "Funil de Obras - Empresas Lider",
      quantidade: 0,
      data: null,
    },
    funilObraFonteCaptacao: {
      id: ++id,
      table: "funilObraFonteCaptacao",
      nome: "Funil de Obras - Fonte de Captação",
      quantidade: 0,
      data: null,
    },
    funilObraJustificativas: {
      id: ++id,
      table: "funilObraJustificativas",
      nome: "Funil de Obras - Justificativas",
      quantidade: 0,
      data: null,
    },
    funilObraUnidadeMedidas: {
      id: ++id,
      table: "funilObraUnidadeMedidas",
      nome: "Funil de Obras - Unidades de medida",
      quantidade: 0,
      data: null,
    },
    funilObraGrupoProdutoUnidadeMedida: {
      id: ++id,
      table: "funilObraGrupoProdutoUnidadeMedida",
      nome: "Funil de Obras - Unidades de medida - Grupos de Produto",
      quantidade: 0,
      data: null,
    },
    funilObraGrupoProdutoMapeamentoInicial: {
      id: ++id,
      table: "funilObraGrupoProdutoMapeamentoInicial",
      nome: "Funil de Obras - Mapeamento Inicial",
      quantidade: 0,
      data: null,
    },
    visitas: { id: ++id, table: "visitas", nome: "Visitas", quantidade: 0, data: null },
    mapaDaMinaOriginal: { id: ++id, table: "mapaDaMinaOriginal", nome: "Mapa da Mina", quantidade: 0, data: null },
    govs: { id: ++id, table: "govs", nome: "Govs", quantidade: 0, data: null },
    equipesVenda: { id: ++id, table: "equipesVenda", nome: "Equipes de Venda", quantidade: 0, data: null },
    escritoriosVenda: { id: ++id, table: "escritoriosVenda", nome: "Escritórios de Venda", quantidade: 0, data: null },
    areasVendaVendedor: { id: ++id, table: "areasVendaVendedor", nome: "Áreas de Venda do Vendedor", quantidade: 0, data: null },
    ultimaVisita: { id: ++id, table: "ultimaVisita", nome: "Última Visita", quantidade: 0, data: null },
    duplaCategoria: { id: ++id, table: "duplaCategoria", nome: "Dupla Categoria", quantidade: 0, data: null },
  };
  if (!table) return Object.values(estrutura);
  return estrutura[table];
}

export function getFunilOptionsView() {
  return [
    { label: "Grupo de produto", value: "grupo_nome" },
    { label: "Etapas de obra", value: "etapa" },
    { label: "Data", value: "proxima_negociacao" },
  ];
}

export function addDays(date, days) {
  date = convertStringInDate(date);
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function convertStringInDate(date, formating = null) {
  if (!date) return "";
  if (date.length > 10) date = date.substring(0, 10);
  const newDate = new Date(date.replace(/-/g, "/"));
  if (newDate == "Invalid Date") return "";
  if (formating == null) return newDate;
  if (formating == "ISO") return newDate.toISOString();
  return newDate.toLocaleDateString(formating);
}

export function getFirstSplitOfDate({ date }) {
  const temp = date?.split("T");
  return temp?.length ? temp[0] : "";
}

export function calcPercent(final, regra) {
  return (100 - (final * 100) / regra) * -1;
}

export function valorMostrar(precoRegra, precoFinal, precoEspecial, precoServico = 0) {
  if (precoFinal == undefined && precoEspecial == undefined) return money(Number(precoRegra) + precoServico);
  if (precoFinal == precoEspecial || precoEspecial == "0.00") return money(Number(precoFinal) + precoServico);
  if (!precoEspecial || precoEspecial == "0.00") return money(Number(precoRegra) + precoServico);
  return money(Number(precoEspecial) + precoServico);
}

export function sum(array, column) {
  return array.reduce((acc, cur) => {
    acc += cur[column] ?? 0;
    return acc;
  }, 0);
}

export function orderDate(array, column, ordem = "asc") {
  return [...array].sort((a, b) => {
    const dateA = new Date(a[column]);
    const dateB = new Date(b[column]);

    if (ordem === "asc") {
      return dateA - dateB; // Menor data vem primeiro
    } else {
      return dateB - dateA; // Maior data vem primeiro
    }
  });
}

export function slug(text) {
  if (!text) return "";
  return text
    .toString()
    .toLowerCase()
    .replace(/[àÀáÁâÂãäÄÅåª]+/g, "a")
    .replace(/[èÈéÉêÊëË]+/g, "e")
    .replace(/[ìÌíÍîÎïÏ]+/g, "i")
    .replace(/[òÒóÓôÔõÕöÖº]+/g, "o")
    .replace(/[ùÙúÚûÛüÜ]+/g, "u")
    .replace(/[ýÝÿŸ]+/g, "y")
    .replace(/[ñÑ]+/g, "n")
    .replace(/[çÇ]+/g, "c")
    .replace(/[ß]+/g, "ss")
    .replace(/[Ææ]+/g, "ae")
    .replace(/[Øøœ]+/g, "oe")
    .replace(/[%]+/g, "pct")
    .replace(/\s+/g, "-")
    .replace(/[^\w\-]+/g, "")
    .replace(/\-\-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
}

export const arrumaFloat = (float) => {
  if (!float) return 0;
  float = float.replace(",", ".");
  return parseFloat(float);
};

export function getPagina(value) {
  const paginas = {
    home: "Página Inicial",
    "cadastro-e-credito": "Cadastro e Crédito",
    carteira: "Cadastro e Crédito > Carteira",
    "carteira/prospect": "Cadastro e Crédito > Carteira > Prospect",
    "carteira/prospect/:parameter": "Cadastro e Crédito > Carteira > Prospect > Cliente {codigo}",
    "carteira/emissor/:parameter": "Cadastro e Crédito > Carteira > Emissor > Cliente {codigo}",
    "carteira/recebedor/:parameter": "Cadastro e Crédito > Carteira > Recebedor > Cliente {codigo}",
    "carteira/credito/:parameter": "Cadastro e Crédito > Carteira > Crédito > Cliente {codigo}",
    "carteira/solicitacoes": "Cadastro e Crédito > Carteira > Solicitações",
    "pesquisa-de-preco/:parameter": "Pesquisa de Preços > Cliente {codigo}",
    "pesquisa-de-preco/:parameter/editar/:number": "Pesquisa de Preços > Cliente {codigo} > Editar",
    "pesquisa-de-preco/:parameter/nova-pesquisa": "Pesquisa de Preços > Cliente {codigo} > Nova Pesquisa",
    simuladores: "Simuladores",
    "simuladores/:parameter/simulacao-nova": "Simuladores > Cliente {codigo} > Nova Simulação",
    "simuladores/:parameter/simulacao/:simulacao": "Simuladores > Cliente {codigo} > Simulação",
    "simuladores/:parameter/simulacao": "Simuladores > Cliente {codigo} > Listagem de Simulações",
    "simuladores/simulacao/:parameter/novo-produto": "Simuladores > Cliente {codigo} > Simulação > Novo Produto",
    "simuladores/simulacao/:parameter/editar": "Simuladores > Cliente {codigo} > Simulação > Editar Produto",
    "simuladores/simulacao/:parameter": "Simuladores > Simulação > Cliente {codigo}",
    "tabela-preco": "Tabela de Preço > Negociações Vigentes > Todas as Negociações",
    "tabela-preco/proximas-do-vencimento": "Tabela de Preço > Negociações Vigentes > Proximas do Vencimento",
    "tabela-preco/minhas-solicitacoes": "Tabela de Preço > Negociações Vigentes > Minhas Solicitações",
    "tabela-preco/preco-regra": "Tabela de Preço > Tabela de Regras > Preços Regra",
    "tabela-preco/prazo-regra": "Tabela de Preço > Tabela de Regras > Prazos Regra",
    "tabela-preco/:parameter": "Tabela de Preço > Preço Cliente {codigo}",
    "tabela-preco/:number" : "Tabela de Preço > Preço Cliente {codigo}",
    "tabela-preco/:parameter/solicitacoes-preco":"Tabela de Preço > Preço Cliente {codigo} > Histórico de Solicitações de Preços",
    "tabela-preco/:number/solicitacoes-preco":"Tabela de Preço > Preço Cliente {codigo} > Histórico de Solicitações de Preços",
    "tabela-preco/:parameter/editar-negociacao": "Tabela de Preço > Cliente {codigo} > Editar Negociação",
    "tabela-preco/:parameter/nova-negociacao": "Tabela de Preço > Cliente {codigo} > Nova Negociação",
    "roteirizacao/mapa": "Roteirização > Mapa",
    "roteirizacao/:parameter": "Roteirização > Cliente {codigo} > Visita",
    "roteirizacao/visitas": "Roteirização > Historico de Visitas",
    "roteirizacao/consulta/:parameter": "Roteirização > Cliente {codigo} > Consulta",
    "roteirizacao/pesquisa-de-preco/:parameter": "Roteirização > Cliente {codigo} > Pesquisa de Preço",
    "funil-de-obras/proximas-negociacoes": "Funil de Obras",
    "funil-de-obras/:parameter": "Funil de Obras > Cliente {codigo}",
    "funil-de-obras/:parameter/mapeamento": "Funil de Obras > Cliente {codigo} > Mapeamento",
    "funil-de-obras/:parameter/mapeamento/:etapa": "Funil de Obras > Cliente {codigo} > Mapeamento > Etapa",
    "funil-de-obras/:parameter/mapeamento/editar/:id": "Funil de Obras > Cliente {codigo} > Mapeamento > Editar",
    "funil-de-obras/obras-ganhas": "Funil de Obras > Obras Ganhas",
    "funil-de-obras/:parameter": "Funil de Obras > Cliente {codigo} > Dashboard",
    "links-uteis": "Links de Apoio",
    "gestao-de-pesquisa/:parameter": "Gestão de Pesquisa > Cliente {codigo}",
    "gestao-de-pesquisa/visualizar/:parameter": "Gestão de Pesquisa > Cliente {codigo} > Visualizar",
    "gestao-de-pesquisa/formularios/:parameter": "Gestão de Pesquisa > Cliente {codigo} > Formulários",
    "gestao-de-pesquisa/historico-formularios/:parameter":
      "Gestão de Pesquisa > Cliente {codigo} > Histórico de Formulários",
    "gestao-de-vendas/posicao-de-carga": "Posição de Carga (pedidos da rota)",
    "gestao-de-vendas/posicao-de-carga/todos": "Posição de Carga (todos os pedidos)",
    "gestao-de-vendas/autosservico": "Autosserviço (clientes da rota)",
    "gestao-de-vendas/autosservico/todos": "Autosserviço (todos os clientes)",
    "gestao-de-vendas/credito-de-clientes": "Crédito de clientes (clientes da rota)",
    "gestao-de-vendas/credito-de-clientes/todos": "Crédito de clientes (todos os clientes)",
    "gestao-de-vendas/relatorio-de-vendas/carteira": "Relatório de Vendas (carteira)",
    "gestao-de-vendas/relatorio-de-vendas/clientes": "Relatório de Vendas (clientes)",
    "gestao-de-vendas/sales-force": "Eficiência de Vendas",
    "gestao-de-vendas/bateu-levou": "Ferramentas: Bateu Levou",
    "gestao-de-vendas/vloz": "Ferramentas: VLOZ",
    "gestao-de-vendas/super4": "Ferramentas: S4",
    apresentacao: "Links de Apoio > Apresentações Vend+",
    "material-de-apoio": "Links de Apoio > Material de Apoio",
    "simulador-imo": "Links de Apoio > Simulador IMO",
    "simulador-cpp": "Links de Apoio > Simulador CPP",
    "simulador-granel": "Links de Apoio > Simulador Granel",
    "dashboard-tac": "Links de Apoio > Dashboard TAC",
    "tatica-cliente": "Links de Apoio > Tática do Cliente",
    reflex: "Links de Apoio > Reflex",
    "reflex/mes-atual": "Reflex > Mês Atual",
    "reflex/historico": "Reflex > Historico",
    "calculadora-pague-flex": "Links de Apoio > Calculadora Pague Flex",
    "app-vloz": "Links de Apoio > App VLOZ",
    "consulta-cnpj": "Links de Apoio > Consulta CNPJ",
    "consulta-cep": "Links de Apoio > Consulta CEP",
    "mapa-obra": "Links de Apoio > Mapa da obra",
    "vc-matrix": "Links de Apoio > Vc Matrix",
    "simulador-vespa-tac": "Links de Apoio > Simulador VESPA TAC",
    "vc-store": "Links de Apoio > VC STORE",
    "relatorios-qlik-sense": "Links de Apoio > Relatórios Qlik Sense",
    cap: "Links de Apoio > CAP",
    "portal-de-aprovacoes": "Links de Apoio > Portal de aprovações",
    concur: "Links de Apoio > Concur",
    "guia-produtos": "Links de Apoio > Guia de Produtos VC",
    lemontech: "Links de Apoio > Lemontech",
    "treinamento-dtm": "Links de Apoio > Treinamento DTM",
  };

  return paginas[value] ?? "";
}

const getServico = (servicos, denominacao, familiaId) => {
  const thisServico = (servicos || []).find((s) => s.denominacao === denominacao && s.familiaId === familiaId);
  return thisServico || (servicos || []).find((s) => s.denominacao === denominacao) || null;
};

export const getFracionamentoDescarga = (servicos, produto) => {
  const thisServicos = (servicos || []).filter((s) => s.filialId === produto.filialId);

  const cargaFracionada = getServico(thisServicos, "VC -CARGA FRACIONADA", produto.familiaId);
  const descargaManual = getServico(thisServicos, "VC -DESCARGA CLIENTE", produto.familiaId);

  const precoFracionamento = cargaFracionada && produto.peso ? (cargaFracionada.porcentagem / 1000) * produto.peso : 0;
  const precoDescarga = descargaManual ? descargaManual.porcentagem : 0;

  return { precoFracionamento, precoDescarga };
};

export const clearCache = async (idCliente) => {
  try {
    const originalClientData = [];
    await db.mapaDaMinaOriginal
      .where("clienteId")
      .equals(+idCliente)
      .each((e) => {
        originalClientData.push(e);
      });

    await resetMapa({ data: originalClientData, table: db.mapaDaMina, clienteId: +idCliente });

    return { success: true, message: "Cache limpo com sucesso!" };
  } catch (error) {
    console.error("Erro ao limpar cache:", error);
    return { success: false, message: "Erro ao limpar cache", error };
  }
};

export const getCodigoExternos = (renovacoesNegociacoes) => {
  let codigosExternos = "";
  if (renovacoesNegociacoes) {
    codigosExternos = (renovacoesNegociacoes || []).reduce((acc, negociacao) => {
      return acc.includes(` - ${negociacao.codigoExterno}`) ? acc : acc + ` - ${negociacao.codigoExterno}`;
    }, "");
  }
  return codigosExternos;
};

export function semanaVigente() {
  const hoje = new Date();
  const diaDaSemana = hoje.getDay();

  const inicioDaSemana = new Date(hoje);
  inicioDaSemana.setDate(hoje.getDate() - diaDaSemana);

  const fimDaSemana = new Date(hoje);
  fimDaSemana.setDate(hoje.getDate() + (6 - diaDaSemana));

  const semana = [];
  let dataAtual = new Date(inicioDaSemana);

  while (dataAtual <= fimDaSemana) {
    semana.push(dataAtual.toLocaleDateString());
    dataAtual.setDate(dataAtual.getDate() + 1);
  }
  return semana;
}

export function todasAsDatasDoMes() {
  const hoje = new Date();
  const datas = [];
  const ultimoDia = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).getDate();

  for (let dia = 1; dia <= ultimoDia; dia++) {
    const data = new Date(hoje.getFullYear(), hoje.getMonth(), dia);
    datas.push(data.toLocaleDateString());
  }

  return datas;
}

export const genericPost = async ({ url, api, data }) => await api.post(url, data).then((response) => response);
